import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core'

import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'
import { CustomNgModel } from '../../helpers/custom-ng-model'
import dayJS from 'dayjs'

@Component({
  selector: 'wm-front-input-date',
  imports: [FormsModule],
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateComponent),
      multi: true,
    },
  ],
})
export class InputDateComponent extends CustomNgModel {
  /** Default date format. May be replaced with an input at a given time */
  private defaultDateFormat = 'DD/MM/YYYY'

  /** Override of the write value */
  public override writeValue(value?: string) {
    this._inputValue = value ? dayJS(value).format(this.defaultDateFormat) : ''
  }

  /**
   * Will be triggered when the nested input will be changed
   * @param {string} value
   */
  public onNewValue(value: string): void {
    const date = dayJS(value, this.defaultDateFormat, true)
    if (date.isValid()) {
      this._onChangeCallback(date)
    }
  }
}
